import {
  GET_PROGRAM_FILTER_CONFIGS,
  GET_PROGRAM_FILTER_CONFIGS_SUCCESS,
  GET_PROGRAM_FILTER_CONFIGS_ERROR,
  GET_PROGRAM_FILTER_CONFIGS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetProgramsFilterConfigs = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROGRAM_FILTER_CONFIGS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_FILTER_CONFIGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_FILTER_CONFIGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PROGRAM_FILTER_CONFIGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetProgramsFilterConfigs;
